import React from "react";
import { APP_BUILD, APP_COMMIT, APP_VERSION, getAppVersionLabel } from "../config/appVersion";
import "../css/app-version.css";

/**
 * Versión de la plataforma y commit del que salió. Es lo que se le muestra a un auditor o a
 * soporte para ubicar la liberación (REG-LIB) de lo que está corriendo. El commit completo va en
 * el tooltip; el texto se puede seleccionar y copiar.
 *
 * @param {string} [version]    MAYOR.MENOR.x del package.json. Por defecto, la del build.
 * @param {string} [build]      Número de pipeline, reemplaza el último número. Por defecto, el del build.
 * @param {string} [commit]     Por defecto, el del build.
 * @param {string} [className]  Variante de ubicación (login, menú).
 */
const AppVersion = ({ version = APP_VERSION, build = APP_BUILD, commit = APP_COMMIT, className = "" }) => (
    <span
        className={`app-version ${className}`.trim()}
        title={commit || undefined}
        data-testid="app-version"
    >
        {getAppVersionLabel({ version, build, commit })}
    </span>
);

export default AppVersion;
